// extracted by mini-css-extract-plugin
export var linkText = "_oc-0";